import { render, staticRenderFns } from "./PatternContentFooter.vue?vue&type=template&id=4e4d4e72&scoped=true&"
var script = {}
import style0 from "./PatternContentFooter.vue?vue&type=style&index=0&id=4e4d4e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d4e72",
  null
  
)

export default component.exports